import Styles from './CustomerStories.module.css'

import type {Cta, ThemedVisual} from '../../../Index.types'
import {ColorDivider} from '../ColorDivider/ColorDivider'

export interface CustomerStoriesProps {
  items: Array<{
    logo: ThemedVisual
    description: string
    cta: Cta
  }>
}

export const defaultProps: Partial<CustomerStoriesProps> = {}

export const CustomerStories = (props: CustomerStoriesProps) => {
  const initializedProps: CustomerStoriesProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return (
    <div className={Styles['CustomerStories']}>
      <ColorDivider variant="3" isThick hasDucky />
    </div>
  )
}
